import styles from './CalendarTimeSlotsIntro.scss';

export const CalendarTimeSlotsIntro = () => (
  <div className={styles.CalendarTimeSlotsIntro} data-testid="CalendarTimeSlotsIntro">
    <p>Your Fitted Bedroom Consultation will last around two hours.</p>
  </div>
);
